import { useEffect, useState } from 'react';
import './Sections.css';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function PaymentStatus() {
  const [status, setStatus] = useState('checking'); // checking | paid | unpaid | error
  const [bill, setBill] = useState(null);

  useEffect(() => {
    // Extract billplz[id] and billplz[paid] from URL params
    const params = new URLSearchParams(window.location.search);
    const billId = params.get('billplz[id]');
    const paid = params.get('billplz[paid]');

    if (!billId) {
      setStatus('error');
      return;
    }

    // Quick check from redirect params
    if (paid === 'true') {
      setStatus('paid');
    }

    // Verify with backend for accuracy
    fetch(`${API_URL}/api/bill-status/${billId}`)
      .then(r => r.json())
      .then(data => {
        setBill(data);
        setStatus(data.paid ? 'paid' : 'unpaid');
      })
      .catch(() => {
        // If backend unreachable, trust redirect param
        if (paid === 'true') setStatus('paid');
        else setStatus('error');
      });
  }, []);

  return (
    <section className="sec payment-status-sec">
      <div className="ps-card">
        {status === 'checking' && (
          <>
            <div className="ps-spinner" />
            <h2>Memeriksa pembayaran...</h2>
            <p>Sila tunggu sebentar.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <div className="ps-icon ps-success">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <h2>Pembayaran Berjaya!</h2>
            <p>Terima kasih atas pembelian anda. Buku TLP akan dihantar dalam 3-5 hari bekerja.</p>
            <p className="ps-detail">Resit dan tracking number akan dihantar ke emel anda.</p>
            {bill && <p className="ps-bill-id">Bill ID: {bill.bill_id}</p>}
            <a href="/" className="btn-gold ps-btn">Kembali ke Laman Utama</a>
          </>
        )}
        {status === 'unpaid' && (
          <>
            <div className="ps-icon ps-fail">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            </div>
            <h2>Pembayaran Tidak Berjaya</h2>
            <p>Pembayaran anda belum selesai. Sila cuba lagi atau hubungi kami.</p>
            {bill?.url && <a href={bill.url} className="btn-gold ps-btn">Cuba Bayar Semula</a>}
            <a href="/" className="btn-ghost ps-btn">Kembali</a>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="ps-icon ps-fail">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h2>Ralat</h2>
            <p>Tidak dapat mengesahkan status pembayaran. Sila hubungi bukufizikaltlp@gmail.com.</p>
            <a href="/" className="btn-gold ps-btn">Kembali ke Laman Utama</a>
          </>
        )}
      </div>
    </section>
  );
}
